import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import BusinessForm from './BusinessForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import schema from 'react/shared/utils/schemas';
import trackUserData from 'react/signups/card/common/MarketoTracker';
import WizardCard from 'react/signups/card/common/WizardCard';
import businessDataShape from 'react/signups/card/shapes/BusinessData';

export default function Business({ businessData, moduleComplete, setBusinessData }) {
  const paidCaregiverSchema = Yup.string()
    .nullable()
    .required('The paid caregiver question is required');
  const validationSchema = Yup.object().shape({
    address: schema.address.required(),
    name: Yup.string().label('Business name').required(),
    numberOfClients: schema.numberOfClients.required(),
    numberOfInitialCards: schema.numberOfInitialCards.required(),
    cardForPaidCaregiver: paidCaregiverSchema,
  });

  const handleContinue = (values) => {
    const cardForPaidCaregiver = values.cardForPaidCaregiver;
    trackUserData({
      Company: values.name,
      of_clients_in_portfolio__c: values.numberOfClients,
      Address: `${values.address.street1} ${values.address.street2}`,
      City: values.address.city,
      State: values.address.state,
      PostalCode: values.address.zip,
    });
    setBusinessData({
      address: values.address,
      name: values.name,
      numberOfClients: values.numberOfClients,
      numberOfInitialCards: values.numberOfInitialCards,
      cardForPaidCaregiver,
    });
  };

  return (
    <WizardCard>
      <CardHeader>{'Tell us about your business'}</CardHeader>
      <Formik
        initialValues={businessData}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleChange, handleSubmit, setFieldValue, setFieldTouched, setValues, values }) => (
          <>
            <BusinessForm
              onChange={handleChange}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              setValues={setValues}
              values={values}
            />
            <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
          </>
        )}
      </Formik>
    </WizardCard>
  );
}

Business.propTypes = {
  businessData: businessDataShape.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  setBusinessData: PropTypes.func.isRequired,
};
